import React, { useEffect, useMemo } from 'react';
import { IItemForGetShortInfo, IGetDishesShort, IGetDishesShortBySubCategoryIdsArguments } from 'types';
import { TCreateTeaserSelectedItem } from 'modules/Teasers/CreateTeaser/createTeaserState/createTeaserContext';
import FormSelect from 'components/Select/FormSelect';
import { useFetchData } from 'hooks/useFetchData';
import { getDishesShortBySubCategoryIds } from 'backend/dishes';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import style from './DishNameSelect.module.scss';

interface IDishNameSelect {
	selectedRestaurants: string[];
	selectedTransitionDishSubCategory: TCreateTeaserSelectedItem;
	setTransitionDishName: (value: TCreateTeaserSelectedItem) => void;
	setFetchedDishes: (value: IItemForGetShortInfo[]) => void;
}

const DishNameSelect: React.FC<IDishNameSelect> = ({
	selectedRestaurants,
	selectedTransitionDishSubCategory,
	setTransitionDishName,
	setFetchedDishes,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<
		IGetDishesShort,
		IGetDishesShortBySubCategoryIdsArguments
	>(selectedTransitionDishSubCategory ? getDishesShortBySubCategoryIds : null, {
		subCategoryIds: [selectedTransitionDishSubCategory || ''],
		restaurantIds: selectedRestaurants,
	});

	const updatedData = useMemo(() => {
		return response?.data.dishes.map((el) => ({
			...el,
			additionalContent: (
				<>{el.externalId && <ChunkOfTextWithCopying text={el.externalId} className={style.externalId} />}</>
			),
		}));
	}, [response]);

	useEffect(() => {
		refetch();
	}, [selectedTransitionDishSubCategory]);

	useEffect(() => {
		response && setFetchedDishes(response.data.dishes);
	}, [response]);

	return (
		<FormSelect
			testId="DishNameSelect"
			name="selectedTransitionDishName"
			label="dishLabel"
			disabled={!selectedTransitionDishSubCategory || loading}
			options={updatedData}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setTransitionDishName}
		/>
	);
};

export default React.memo(DishNameSelect);
